import { render, staticRenderFns } from "./StaffClockinHistory.vue?vue&type=template&id=1945b986"
import script from "./StaffClockinHistory.vue?vue&type=script&lang=js"
export * from "./StaffClockinHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports